module.exports = __webpack_public_path__ + "static/img/n_address.89eea77.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/n_address.png
// module id = AIvM
// module chunks = 0